import React from 'react'

const SEGMENTS = [
  { key: 'bothPrepared', label: 'Both prepared', color: '#639922' },
  { key: 'managerOnly', label: 'Manager only', color: '#BA7517' },
  { key: 'reportOnly', label: 'Report only', color: '#EF9F27' },
  { key: 'neitherPrepared', label: 'Neither', color: '#B4B2A9' },
]

export function PrepQualityDonut({ breakdown }) {
  const b = breakdown || {}
  const total = SEGMENTS.reduce((sum, s) => sum + (b[s.key] || 0), 0)
  const R = 60
  const C = 2 * Math.PI * R
  let offset = 0

  const hint = oneSidedHint(b)

  return (
    <div>
      <div style={styles.row}>
        <svg width={160} height={160} viewBox="0 0 160 160" role="img" aria-label="Prep quality breakdown">
          <circle cx={80} cy={80} r={R} fill="none" stroke="var(--border)" strokeWidth={22} />
          {total > 0 && SEGMENTS.map((s) => {
            const v = b[s.key] || 0
            if (!v) return null
            const len = (v / total) * C
            const dash = `${len} ${C - len}`
            const el = (
              <circle
                key={s.key}
                cx={80} cy={80} r={R} fill="none"
                stroke={s.color} strokeWidth={22}
                strokeDasharray={dash}
                strokeDashoffset={-offset}
                transform="rotate(-90 80 80)"
              />
            )
            offset += len
            return el
          })}
          <text x={80} y={78} textAnchor="middle" fontSize={22} fontWeight={600} fill="var(--text-primary)">
            {total}
          </text>
          <text x={80} y={96} textAnchor="middle" fontSize={10} fill="var(--text-secondary)">
            sessions
          </text>
        </svg>
        <div style={styles.legend}>
          {SEGMENTS.map((s) => {
            const v = b[s.key] || 0
            const pct = total ? Math.round((v / total) * 100) : 0
            return (
              <div key={s.key} style={styles.legendRow}>
                <span style={{ ...styles.swatch, background: s.color }} />
                <span style={styles.legendLabel}>{s.label}</span>
                <span style={styles.legendVal}>{v} ({pct}%)</span>
              </div>
            )
          })}
        </div>
      </div>
      <div style={styles.divider} />
      <div style={styles.onesidedTitle}>One-sided prep — who's preparing?</div>
      <div style={styles.tiles}>
        <div style={styles.tile}>
          <div style={styles.tileVal}>{b.managerOnly || 0}</div>
          <div style={styles.tileLabel}>manager only</div>
        </div>
        <div style={styles.tile}>
          <div style={styles.tileVal}>{b.reportOnly || 0}</div>
          <div style={styles.tileLabel}>report only</div>
        </div>
      </div>
      {hint && <div style={styles.hint}>{hint}</div>}
    </div>
  )
}

function oneSidedHint(b) {
  const m = b.managerOnly || 0
  const r = b.reportOnly || 0
  const tot = m + r
  if (tot < 5) return null
  const maxSide = Math.max(m, r)
  if (maxSide / tot <= 0.66) return null
  return m > r
    ? "Reports may not be bought in — consider a team walkthrough."
    : "Managers aren't preparing — check in with the team."
}

const styles = {
  row: { display: 'flex', gap: 20, alignItems: 'center' },
  legend: { display: 'flex', flexDirection: 'column', gap: 8, flex: 1, fontSize: 12 },
  legendRow: { display: 'flex', alignItems: 'center', gap: 8 },
  swatch: { width: 10, height: 10, borderRadius: 2, display: 'inline-block' },
  legendLabel: { flex: 1, color: 'var(--text-primary)' },
  legendVal: { color: 'var(--text-secondary)', fontVariantNumeric: 'tabular-nums' },
  divider: { height: 1, background: 'var(--border)', margin: '18px 0' },
  onesidedTitle: { fontSize: 12, color: 'var(--text-secondary)', marginBottom: 10 },
  tiles: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 },
  tile: { border: '1px solid var(--border)', borderRadius: 8, padding: 10, textAlign: 'center' },
  tileVal: { fontSize: 20, fontWeight: 600 },
  tileLabel: { fontSize: 11, color: 'var(--text-secondary)' },
  hint: { marginTop: 10, fontSize: 12, color: '#7A4A0F', background: '#FCE9CF', padding: '6px 10px', borderRadius: 6 },
}
